/*
 * @Author: LHH
 * @Date: 2019-08-12 15:08:25
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import MetaInfo from 'vue-meta-info'
import lottie from 'vue-lottie'

// pxtorem 适配方案
import 'amfe-flexible/index'

// 引入公有样式
import './assets/less/public.less'

Vue.config.productionTip = false

Vue.use(MetaInfo)
// lottie动画
Vue.component('lottie', lottie)

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
